export const API = process.env.REACT_APP_API_URL;
export const SOCKET_API = process.env.REACT_APP_SOCKET_API_URL;
export const Image_API = process.env.REACT_APP_IMAGE_API_URL;